// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// function DemoSelector() {
//   const navigate = useNavigate();

//   const handleDemoSelection = (difficulty) => {
//     navigate(`/demo/${difficulty}`);
//   };

//   return (
//     <div className="container" style={styles.container}>
//       <h1>Select a Demo Case</h1>
//       <div style={styles.buttonContainer}>
//         <button
//           onClick={() => handleDemoSelection('easy')}
//           style={{ ...styles.button, backgroundColor: '#a8dadc' }} // Soft pastel green
//         >
//           Clinical Decision-Making: Easy
//         </button>
//         <button
//           onClick={() => handleDemoSelection('medium')}
//           style={{ ...styles.button, backgroundColor: '#f4a261' }} // Soft pastel orange
//         >
//           Clinical Decision-Making: Medium
//         </button>
//         <button
//           onClick={() => handleDemoSelection('hard')}
//           style={{ ...styles.button, backgroundColor: '#e76f51' }} // Soft pastel red
//         >
//           Clinical Decision-Making: Hard
//         </button>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     textAlign: 'center',
//     marginTop: '50px',
//   },
//   buttonContainer: {
//     display: 'flex',
//     flexDirection: 'column', // Makes buttons stack vertically
//     alignItems: 'center', // Centers buttons horizontally
//     gap: '20px', // Adds spacing between buttons
//   },
//   button: {
//     width: '200px',
//     height: '50px',
//     fontSize: '18px',
//     fontWeight: 'bold',
//     borderRadius: '10px', // Subtle rounded corners
//     border: 'none',
//     cursor: 'pointer',
//     color: 'white', // Text color for contrast
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Minimal shadow for depth
//     transition: 'transform 0.2s, box-shadow 0.2s', // Smooth hover animation
//   },
// };

// export default DemoSelector;
import React from 'react';
import { useNavigate } from 'react-router-dom';

function DemoSelector() {
  const navigate = useNavigate();

  const handleDemoSelection = (slug) => {
    navigate(`/demo/${slug}`);
  };

  // Edit labels freely; make sure slugs match your backend route keys
  const CASES = [
    // Existing demos (text updated)
    { slug: 'easy',   label: 'Clinical Decision-Making: Easy',  color: '#a8dadc' },
    { slug: 'medium', label: 'Clinical Decision-Making: Medium',      color: '#f4a261' },
    { slug: 'hard',   label: 'Clinical Decision-Making: Hard', color: '#e76f51' },

    // NEW demos (example slugs — replace with your real case keys)
    { slug: 'procedures', label: 'Procedures Case', color: '#6c9bd2' },
    { slug: 'ultrasound',         label: 'Ultrasound',   color: '#8fb996' },
    { slug: 'difficultconversation',         label: 'Difficult Conversation', color: '#b980f0' },
  ];

  return (
    <div className="container" style={styles.container}>
      <h1>Select a Demo Case</h1>
      <div style={styles.buttonContainer}>
        {CASES.map(({ slug, label, color }) => (
          <button
            key={slug}
            onClick={() => handleDemoSelection(slug)}
            style={{ ...styles.button, backgroundColor: color }}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}

const styles = {
  container: {
    textAlign: 'center',
    marginTop: '50px',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
  },
  button: {
    width: '260px',
    height: '52px',
    fontSize: '18px',
    fontWeight: 'bold',
    borderRadius: '10px',
    border: 'none',
    cursor: 'pointer',
    color: 'white',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.2s, box-shadow 0.2s',
  },
};

export default DemoSelector;
